export function ChevronLeftIcon() {
  return (
    <svg
						enableBackground="new 0 0 24 24"
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="m15 6-6 6 6 6"
							fill="none"
							stroke="#a12971"
							strokeWidth="2"
						/>
					</svg>
  );
}